
export enum SituacaoAnalise {
  PENDENTE = 'PENDENTE',
  ANALISADA = 'ANALISADA',
  AMBAS = 'AMBAS',
}
